import ActionTypes from "../../../constants";
import { ChangeLogReducerType } from "../types";

const initialState: ChangeLogReducerType = {
  changeLog: null,
  paginationInfo: {
    currentPage: 1,
    pageSize: 15,
    totalRecords: 0,
  },
  users: null
};

const changeLog = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_CHANGE_LOG_SUCCEEDED: {
      const { changeLog, paginationInfo } = action;
      return {
        ...state,
        changeLog,
        paginationInfo
      };
    }
    case ActionTypes.FETCH_USERS_SUCCEEDED: {
      const { users } = action;
      return {
        ...state,
        users,
      };
    }
    case ActionTypes.RESET_DATA: {
      return {
        ...state,
        changeLog: [],
        paginationInfo: {
          currentPage: 1,
          totalRecords: 0,
        }
      };
    }
    default: {
      return state;
    }
  }
};

export default changeLog;
